module.exports = __webpack_public_path__ + "img/20200514_143707.1b06e5ff.jpg";